<template>
    <div
        class="CBadge inline-flex rounded-md text-xs uppercase leading-3"
        :title="props.title"
        :class="{
            'px-2 py-1.5 font-semibold': !props.thinText,
            'px-1.5 pb-[3px] pt-1': props.thinText,
            'absolute bottom-4 left-4': props.position === 'fixed',
            'bg-gray-500 text-white': props.type === 'default',
            'bg-primary-500 text-white': props.type === 'primary',
            'bg-[#047274] text-white': props.type === 'teal',
            'bg-yellow-500 text-gray-900 dark:text-txt-headings': props.type === 'yellow',
            'bg-secondary-500 text-black': props.type === 'secondary',
            'bg-green-400 text-white': props.type === 'success',
            'bg-blue-900 text-white': props.type === 'purple',
            'bg-gray-900 text-white': props.type === 'black',
            'bg-red-500 text-white': props.type === 'red',
            'bg-primary-100 dark:bg-primary-950/40 text-primary-950 dark:text-primary-300': props.type === 'info',
            // Same look as info, but opaque in dark mode too, for badges laid over images
            'bg-primary-100 text-primary-950': props.type === 'info-solid',
            'bg-green-600 text-white': props.type === 'volunteer',
            'bg-orange-500 text-white': props.type === 'orange',
            'bg-pink-500 text-white': props.type === 'pink',
            'bg-blue-500 text-white': props.type === 'blue',
            'bg-gray-400 dark:bg-subtle text-white': props.type === 'gray',
            'bg-[#c24cfc] text-white': props.type === 'violet'
        }"
    >
        <slot />
    </div>
</template>

<script setup lang="ts">
type BadgeType = 'default' | 'primary' | 'secondary' | 'success' | 'purple' | 'black' | 'red' | 'info' | 'info-solid'
type Position = 'fixed'

interface Props {
    type?: string
    position?: Position
    thinText?: boolean
    title?: string
}

const props = withDefaults(defineProps<Props>(), {
    type: 'default',
    position: undefined,
    thinText: false,
    title: ''
})
</script>
